import { helper } from '@ember/component/helper';
import { htmlSafe } from '@ember/template';
export const highlightSubstr = ([text, termToHighlight]) => {
  return htmlSafe(text.replace(new RegExp(termToHighlight, 'i'), '<b>$&</b>'));
};
export default helper(highlightSubstr);